import { ChatSocketProvider } from 'src/realtime/ChatSocketProvider';
import { useQuoteWorkflowRefresh, quoteWorkflowRefreshInterval } from '../useQuoteWorkflowRefresh';
import { refreshSavedQuoteWorkflow } from '../refreshSavedQuoteWorkflow';
import { rateTypeDisplayLabel } from 'src/utils/rateTypeIdentity';
import { unresolvedClientRate } from '../BoundClientRateSelect';
import { formatMoney } from 'src/utils/formatters';
import ResponsiveCommunicationTable from '../ResponsiveCommunicationTable';
import { DocumentThemeScope } from 'src/content/applications/quote/DocumentThemeScope';
import { adminActionButtonSx } from 'src/theme/adminActionButton';
import { clientDocumentBranding, ClientDocumentLogo } from 'src/content/applications/quote/clientDocumentBranding';
import DepositSentStatus from '../DepositSentStatus';
import { isQuoteApprovedForActions } from '../quoteSafety';
import {
  Box,
  Alert,
  Button,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Autocomplete from 'react-google-autocomplete';
import { useLocation, useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
// @ts-ignore
import 'react-toastify/dist/ReactToastify.css';
import {
  createQuote,
  getAllPositions,
  getAllPositionsCategories,
  getQuoteById,
  getEventAgreement,
  sendDesposit,
  updateQuote
} from '../../../../helper/backend_helper';
import moment from 'moment';
import {
  EditOutlined,
  Email,
  KeyboardBackspace,
  Task
} from '@mui/icons-material';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import EventDetailsModal from './eventDetailsModal';
import ShiftForm from './shiftModal';
import EditShiftForm from './editShiftModal';
import { formatDate } from 'src/utils/date';
import { useClientDocumentPDF } from 'src/content/applications/quote/useClientDocumentPDF';
import { DepositModal } from './DepositeModal';
import { formatNumber } from 'src/utils/formatters';
import { savedQuoteRateTypes } from '../updateQuote/savedQuoteRateTypes';
// import { DiscountModal } from './DiscountModal';
import { AdminFeeModal } from './AdminFeeModal';
import EmailTemplateModal from './emailTemplateModal';
import './depositWorksheet.css';
const cityTimezones = require('city-timezones');

interface SavedValue {
  type: 'percentage' | 'fixed';
  amount: number;
  depositAmount: number;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};

const timeZoneMapping = {
  'America/New_York': 'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Chicago': 'Central Standard Time (CST/CDT) - UTC-6 / UTC-5',
  'America/Denver': 'Mountain Standard Time (MST/MDT) - UTC-7 / UTC-6',
  'America/Los_Angeles': 'Pacific Standard Time (PST/PDT) - UTC-8 / UTC-7',
  'America/Anchorage': 'Alaska Standard Time (AKST/AKDT) - UTC-9 / UTC-8',
  'Pacific/Honolulu': 'Hawaii-Aleutian Standard Time (HST) - UTC-10',
  'America/Halifax': 'Atlantic Standard Time (AST) - UTC-4',
  'Pacific/Guam': 'Chamorro Standard Time (ChST) - UTC+10',
  'Asia/Karachi': 'Pakistan Standard Time (PST) - UTC+5'
};

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const UpdateDeposit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  useQuoteWorkflowRefresh(id);
  const { data: quoteData } = useQuery(['qoute', id], () => getQuoteById(id), {
    enabled: Boolean(id), select: response => response?.data?.data, retry: false,
    refetchInterval: quoteWorkflowRefreshInterval
  });
  const hydratedEvent = React.useRef<string | null>(null);
  const companyData = clientDocumentBranding(quoteData);
  const depositAgreementQuery = useQuery(['event-agreement', Number(id)], () => getEventAgreement(id), {
    enabled: Boolean(id), select: (response) => response?.data?.data, retry: false
  });
  const rateTypeOptions = savedQuoteRateTypes(depositAgreementQuery.data);


  const data = localStorage.getItem('PLS');
  const userDetail = data ? JSON.parse(data)?.user : null;
  console.log('user email', userDetail.email);

  useEffect(() => {
    if (!quoteData || Number(quoteData.id) !== Number(id) || hydratedEvent.current === id) return;
    hydratedEvent.current = id;
    const quoute = quoteData;
      // Set all state values from the fetched data
      setVenue(quoute?.venue || '');
      setTitle(quoute?.title || '');
      setName(quoute?.name || '');
      setBillTo(quoute?.billTo || '');
      setPayTo(quoute?.payTo || '');
      setClientPo(quoute?.clientPo || '');
      setClientEmail(quoute?.clientEmail || '');
      setTimezone(quoute?.timezone || '');
      setAddress(quoute?.address || '');
      setCity(quoute?.city || '');
      setState(quoute?.state || '');
      setLatitude(quoute?.latitude || null);
      setLongitude(quoute?.longitude || null);
      setChecked(quoute?.isAdminFee || false);
      setSavedValue({
        type: 'fixed',
        amount: quoute?.depositPaid || 0,
        depositAmount: quoute?.depositPaid || 0
      } as SavedValue);

      // Set ccEmails array
      setCcEmails(quoute?.ccEmails ? quoute.ccEmails.split(',') : []);

      setAdminFee({
        type: quoute?.adminFeeType,
        amount:
          quoute?.adminFeeType === 'percentage'
            ? quoute?.adminFeePercentage
            : quoute?.adminFee
      });

      setPositions(
        (quoute.shifts ?? [])
          .map((item, index) => {
            const startTime = moment(item.startTime, 'HH:mm', true);
            const endTime = moment(item.endTime, 'HH:mm', true);

            return {
              id: item.id,
              shiftNumber: item.shiftNumber,
              startDate: item?.startDate,
              endDate: item?.endDate,

              startTime: item.startTime,
              endTime: item.endTime,
              quantity: Number(item?.quantity),
              availableQuantity: Number(item?.availableQuantity),
              position: item?.position,
              notes: item?.notes,
              rateType: item?.rateType,
              rateTypeLabel: item?.rateTypeLabel,
              callType: item?.callType,
              mealBreak: item?.mealBreak,
              rate: Number(item?.rate),
              desiredRate: Number(item?.desiredRate),
              calculatedHours: item?.calculatedHours,
              registerHours: item?.registerHours,
              overTimeHours: item?.overTimeHours,
              DoubleTimeHours: item?.DoubleTimeHours,
              addOns: item?.addOns,
              totals: item?.total,
              status: item?.status,
              isLive: true
            };
          })
          .sort((a, b) => a.startDate - b.startDate)
      );
  }, [id, quoteData]);

  const [checked, setChecked] = useState(quoteData?.isAdminFee);

  const handleCheckboxChange = () => {
    setChecked(!checked);
    // setChecked(event.target.checked);
  };

  const [openEventModal, setOpenEventModal] = useState(false);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [shiftOpen, setShiftOpen] = React.useState(false);
  const handleOpenShift = () => setShiftOpen(true);
  const handleCloseShift = () => setShiftOpen(false);

  const [selectedShift, setSelectedShift] = useState(null);
  const [editShiftOpen, setEditShiftOpen] = React.useState(false);
  const handleOpenEditShift = () => setEditShiftOpen(true);
  const handleCloseEditShift = () => setEditShiftOpen(false);

  const [address, setAddress] = useState(quoteData?.address);
  const [city, setCity] = useState(quoteData?.city);
  const [state, setState] = useState(quoteData?.state);

  const [latitude, setLatitude] = useState(quoteData?.latitude);
  const [longitude, setLongitude] = useState(quoteData?.longitude);

  const [loading, setLoading] = useState(false);

  const handlePlaceSelect = async (place) => {
    // console.log(place);

    if (!place.geometry || !place.formatted_address) {
      console.error('Invalid place:', place);
      return;
    }

    let locality = '';
    let administrative_area_level_1 = '';

    place.address_components.forEach((component) => {
      if (component.types.includes('locality')) {
        locality = component.long_name;
      } else if (component.types.includes('administrative_area_level_1')) {
        administrative_area_level_1 = component.long_name;
      }
    });

    const location = place.formatted_address;
    const latitude = place.geometry.location.lat();
    const longitude = place.geometry.location.lng();

    setAddress(location);
    setLatitude(latitude);
    setLongitude(longitude);
    setCity(locality);
    setState(administrative_area_level_1);

    setTimezone('N/A');
    if (locality) {
      const cityLookup = cityTimezones.lookupViaCity(locality);

      setTimezone(timeZoneMapping[cityLookup[0].timezone] || 'N/A');
    }

    // const cityLookup = cityTimezones.lookupViaCity(locality);
    // setTimezone(timeZoneMapping[cityLookup[0].timezone]);
  };
  const [venue, setVenue] = useState(quoteData?.venue);
  const [title, setTitle] = useState(quoteData?.title);
  const [name, setName] = useState(quoteData?.name);
  const [billTo, setBillTo] = useState(quoteData?.billTo);
  const [payTo, setPayTo] = useState(quoteData?.payTo);
  const [clientPo, setClientPo] = useState(quoteData?.clientPo);
  const [clientEmail, setClientEmail] = useState(quoteData?.clientEmail);
  const [timezone, setTimezone] = useState(quoteData?.timezone);

  const [ccEmails, setCcEmails] = useState(
    quoteData?.ccEmails ? quoteData?.ccEmails.split(',') : []
  );

  const [emailTemplateBody, setEmailTemplateBody] = useState('');
  console.log('emailTemplateBody', emailTemplateBody);

  const [emailTemplateModalOpen, setEmailTemplateModalOpen] = useState(false);

  const [ccEmail, setCcEmail] = useState('');
  const [ccEmailError, setCCEmailError] = useState(false);

  const [locationsError, setLocationsError] = useState(false);
  const [venueError, setVenueError] = useState(false);
  const [titleError, setTitleError] = useState(false);
  const [billToError, setBillToError] = useState(false);
  const [payToError, setPayToError] = useState(false);
  const [clientPOError, setClientPOError] = useState(false);
  const [clientEmailError, setClientEmailError] = useState(false);
  const [timeZoneError, setTimeZoneError] = useState(false);

  const checkValid = () => {
    let isValid = true;
    setLocationsError(false);
    setTitleError(false);
    setBillToError(false);
    setPayToError(false);
    setClientPOError(false);
    setClientEmailError(false);

    if (!address || address.trim() === '') {
      setLocationsError(true);
      isValid = false;
    }

    if (!title || title.trim() === '') {
      setTitleError(true);
      isValid = false;
    }
    if (!venue || venue.trim() === '') {
      setVenueError(true);
      isValid = false;
    }

    if (!billTo || billTo.trim() === '') {
      setBillToError(true);
      isValid = false;
    }

    if (!payTo || payTo.trim() === '') {
      setPayToError(true);
      isValid = false;
    }

    if (!clientEmail || clientEmail.trim() === '') {
      setClientEmailError(true);
      isValid = false;
    }

    if (!timezone || timezone.trim() === '') {
      setTimeZoneError(true);
      isValid = false;
    }

    return isValid;
  };

  const [positions, setPositions] = useState([]);
  const [discount, setDiscount] = useState<any>({
    type: 'fixed',
    amount: quoteData?.discountValue || 0
  });

  const [isAdminFeeModalOpen, setIsAdminFeeModalOpen] = useState(false);
  const [adminFee, setAdminFee] = useState<any>({
    type: 'fixed',
    amount: 5
  });
  console.log(adminFee);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isDiscountModalOpen, setIsDiscountModalOpen] = useState(false);

  const [savedValue, setSavedValue] = useState<SavedValue | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('createDeposit') !== 'true' || String(quoteData?.id) !== id) return;
    if (!quoteData.isDepositSent) setModalOpen(true);
    params.delete('createDeposit');
    navigate({ pathname: location.pathname, search: params.toString(), hash: location.hash }, { replace: true });
  }, [id, quoteData, location.pathname, location.search, location.hash, navigate]);

  //   const grandTotalWithoutAdminFee = Object.values(positions)?.reduce(
  //     (acc, { totals }) => acc + totals,
  //     0
  //   ) as number;

  const grandTotalWithoutAdminFee = useMemo(() => {
    if (!positions || !Array.isArray(positions)) {
      return 0;
    }

    return positions.reduce((acc, position) => {
      const total = position?.totals || 0;
      return acc + total;
    }, 0);
  }, [positions]);

  // const fivePercent = grandTotalWithoutAdminFee * 0.05;

  // const adminFeeValue = checked ? fivePercent : 0;

  const adminFeeValue =
    adminFee.type === 'percentage'
      ? (grandTotalWithoutAdminFee * adminFee.amount) / 100
      : adminFee.amount;

  const grandTotalWithAdminFee = grandTotalWithoutAdminFee + adminFeeValue;

  const discountValue = discount.amount;

  const discountPercentage =
    discount.type === 'percentage'
      ? discount.amount
      : ((discount.amount / grandTotalWithoutAdminFee) * 100).toFixed(2);

  const newGrandTotal = grandTotalWithAdminFee - discountValue;

  const formattedGrandTotalWithAdminFee = Number(newGrandTotal).toFixed(2);

  const dueNow = newGrandTotal - savedValue?.amount || 0;
  const depositRequestSent = Boolean(quoteData?.isDepositSent) && Number(savedValue?.amount) === Number(quoteData?.depositPaid);

  const handleSendQuote = async (status) => {
    const user = JSON.parse(localStorage.getItem('PLS'))?.user;

    if (positions.length === 0) {
      return;
    }

    const sortedPositionsData =
      positions && Array.isArray(positions)
        ? positions.sort(
            (a, b) =>
              new Date(a?.startDate).getTime() -
              new Date(b?.startDate).getTime()
          )
        : [];

    let startDateEvent = sortedPositionsData[0]?.startDate.includes('T')
      ? sortedPositionsData[0]?.startDate.split('T')[0]
      : sortedPositionsData[0]?.startDate;
    let endDateEvent = sortedPositionsData[
      positions.length - 1
    ]?.endDate.includes('T')
      ? sortedPositionsData[positions.length - 1]?.endDate.split('T')[0]
      : sortedPositionsData[positions.length - 1]?.endDate;

    const submitData = {
      // id: quoteData.id,
      venue,
      title,
      name,
      address,
      latitude,
      longitude,
      startDate: startDateEvent,
      endDate: endDateEvent,
      city,
      state,
      billTo,
      payTo,
      clientPo,
      clientEmail,
      from: user?.email,
      isAdminFee: checked,
      adminFeePercentage: '5',
      status,
      userId: user?.id,
      timezone,
      adminFee: adminFeeValue,
      grandTotal: grandTotalWithAdminFee,
      discountValue,
      discountPercentage: discountPercentage ? Number(discountPercentage) : 0,

      shifts: positions.map((item) => {
        return {
          id: item.id,
          eventId: Number(id),
          shiftNumber: item.shiftNumber,
          startDate: item.startDate.includes('T')
            ? item.startDate.split('T')[0]
            : item.startDate,
          endDate: item.endDate.includes('T')
            ? item.endDate.split('T')[0]
            : item.endDate,
          position: item.position,
          quantity: Number(item.quantity),
          availableQuantity: Number(item.availableQuantity),
          startTime: item.startTime,
          endTime: item.endTime,
          timezone: item.timezone,
          notes: item.notes,
          rateType: item.rateType,
          callType: item.callType,
          mealBreak: item.mealBreak,
          rate: item.rate ? Number(item.rate) : 0,
          desiredRate: item.desiredRate ? Number(item.desiredRate) : 0,
          calculatedHours: item.calculatedHours
            ? Number(item.calculatedHours)
            : 0,
          registerHours: item.registerHours ? Number(item.registerHours) : 0,
          overTimeHours: item.overTimeHours ? Number(item.overTimeHours) : 0,
          DoubleTimeHours: item.DoubleTimeHours
            ? Number(item.DoubleTimeHours)
            : 0,
          addOns: item.addOns ? Number(item.addOns) : 0,
          total: item.totals ? item.totals : 0
        };
      })
    };

    // return console.log(submitData);

    try {
      setLoading(true);

      const response = await updateQuote(quoteData.id, submitData);
      // toast.success('Quote updated successfully');
      await refreshSavedQuoteWorkflow(queryClient, quoteData.id);
      // navigate('/dashboards/quote');
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error?.response?.status >= 400 && error?.response?.status <= 499) {
        return Swal.fire({
          title: 'Error',
          text: error?.response?.data?.message,
          icon: 'error'
        });
      }
      Swal.fire({
        title: 'Error',
        text: error?.message,
        icon: 'error'
      });
    }
  };

  const handleSendDeposit = async () => {
    setEmailTemplateModalOpen(true);
  };

  const handelSubmit = async (body, emailTemplateSubject = '', bccEmails: string[] = [], composeCcEmails?: string[], _allowPlatformSender = false, composeToEmails?: string[]) => {
    try {
      setLoading(true);
      console.log('body', body);
      const user = JSON.parse(localStorage.getItem('PLS'))?.user;

      const sortedPositionsData =
        positions && Array.isArray(positions)
          ? positions.sort(
              (a, b) =>
                new Date(a.startDate).getTime() -
                new Date(b.startDate).getTime()
            )
          : [];

      let startDateEvent = sortedPositionsData[0]?.startDate.includes('T')
        ? sortedPositionsData[0]?.startDate.split('T')[0]
        : sortedPositionsData[0]?.startDate;
      let endDateEvent = sortedPositionsData[
        positions.length - 1
      ]?.endDate.includes('T')
        ? sortedPositionsData[positions.length - 1]?.endDate.split('T')[0]
        : sortedPositionsData[positions.length - 1]?.endDate;

      const depositData = {
        isDepositSent: true,
        depositPaidPercent: (savedValue?.amount / newGrandTotal) * 100,
        depositPaid: savedValue?.amount,
        remainingBalance: dueNow,
        emailTemplateBody: body,
        emailTemplateSubject,
        from: user?.email,
        // Complete event data
        venue,
        title,
        name,
        address,
        latitude,
        longitude,
        startDate: startDateEvent,
        endDate: endDateEvent,
        city,
        state,
        billTo,
        payTo,
        clientPo,
        clientEmail: composeToEmails ? composeToEmails.join(',') : clientEmail,
        bccEmails,
        ccEmails: (composeCcEmails ?? ccEmails).join(','),
        isAdminFee: checked,
        adminFeePercentage:
          adminFee.type === 'percentage' ? adminFee.amount : '0',
        adminFee: adminFeeValue,
        adminFeeType: adminFee.type,
        timezone,
        grandTotal: newGrandTotal,
        discountValue,
        discountPercentage: discountPercentage ? Number(discountPercentage) : 0,
        discountType: discount.type,
        shifts: positions.map((item) => {
          return {
            id: item.id,
            eventId: Number(id),
            shiftNumber: item.shiftNumber,
            startDate: item.startDate.includes('T')
              ? item.startDate.split('T')[0]
              : item.startDate,
            endDate: item.endDate.includes('T')
              ? item.endDate.split('T')[0]
              : item.endDate,
            position: item.position,
            quantity: Number(item.quantity),
            availableQuantity: Number(item.availableQuantity),
            startTime: item.startTime,
            endTime: item.endTime,
            timezone: item.timezone,
            notes: item.notes,
            rateType: item.rateType,
            callType: item.callType,
            mealBreak: item.mealBreak,
            rate: item.rate ? Number(item.rate) : 0,
            desiredRate: item.desiredRate ? Number(item.desiredRate) : 0,
            calculatedHours: item.calculatedHours
              ? Number(item.calculatedHours)
              : 0,
            registerHours: item.registerHours ? Number(item.registerHours) : 0,
            overTimeHours: item.overTimeHours ? Number(item.overTimeHours) : 0,
            DoubleTimeHours: item.DoubleTimeHours
              ? Number(item.DoubleTimeHours)
              : 0,
            addOns: item.addOns ? Number(item.addOns) : 0,
            total: item.totals ? item.totals : 0
          };
        })
      };
      // return console.log(depositData);

      const response = await sendDesposit(quoteData.id, depositData);

      // toast.success('Deposit sent successfully');
      await refreshSavedQuoteWorkflow(queryClient, quoteData.id);
      setLoading(false);
      const workspaceSearch = new URLSearchParams(location.search);
      workspaceSearch.delete('createDeposit');
      workspaceSearch.set('tab', 'dashboard');
      const workspaceState: Record<string, unknown> = { ...(location.state || {}) };
      delete workspaceState.tab;
      navigate(`/dashboards/jobTracker/positions/${quoteData.id}?${workspaceSearch.toString()}`, {
        replace: true,
        state: workspaceState
      });
    } catch (error) {
      setLoading(false);
      throw error;
    }
  };

  const handleAddPosition = (newShift) => {
    // const newId = Date.now();
    const newId =
      Math.floor(Date.now() / 1000) + Math.floor(Math.random() * 1000);

    const newPositions = positions;
    newPositions.push({
      id: newId,
      availableQuantity: newShift.quantity,
      isLive: false,
      ...newShift
    });

    setPositions([...newPositions]);
  };

  const {
    data: positionsArray,

    isLoading,
    isError
  }: any = useQuery(
    ['positions_categories'], // Unique key for caching
    () => getAllPositionsCategories(), // Fetch function
    {
      keepPreviousData: true // Keeps previous data while fetching new data
    }
  );

  const sortedPositionsData =
    positions && Array.isArray(positions)
      ? positions.sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        )
      : [];

  const groupedData = sortedPositionsData.reduce((acc, position) => {
    // Ensure startDate is properly formatted
    const date = new Date(position?.startDate).toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit'
    });

    if (!acc[date]) acc[date] = { positions: [], total: 0 };
    acc[date].positions.push(position);
    acc[date].total += Number(position?.totals) || 0;

    return acc;
  }, {});

  const { toPDF, targetRef } = useClientDocumentPDF({
    filename: `${title}_quote_${city}.pdf`
  });
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    await toPDF();
    setDownloading(false);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  //   if (isLoadingQuote) {
  //     return <CircularProgress size={15} />;
  //   }

  return (
    <Card sx={{ pb: 4, height: '100%', overflow: 'auto' }}>
      <Helmet>
        <title>Dashboard | Update Quote</title>
      </Helmet>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          mr: 6,
          ml: 5

          // mt: 2
        }}
      >
        <Stack padding={1} direction="row" alignItems="center" spacing={2}>
          <KeyboardBackspace
            onClick={handleBackClick}
            sx={{ cursor: 'pointer' }}
          />
          <Typography variant="h4">Deposit</Typography>
        </Stack>
      </Box>



      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          paddingRight: 6,
          pt: 2
        }}
      >
        <Button
          size="small"
          sx={{
            width: 150,
            ...adminActionButtonSx
          }}
          onClick={handleDownload}
          disabled={downloading}
        >
          {downloading ? (
            <CircularProgress size={24} sx={{ color: 'white' }} />
          ) : (
            'Download PDF'
          )}
        </Button>
      </Box>
      {openEventModal && (
        <EventDetailsModal
          openEventModal={openEventModal}
          setOpenEventModal={setOpenEventModal}
          data={{
            venue,
            title,
            name,
            billTo,
            payTo,
            clientPo,
            clientEmail,
            ccEmails,
            timezone
          }}
          onSubmit={(values) => {
            setVenue(values.venue);
            setTitle(values.title);
            setName(values.name);
            setBillTo(values.billTo);
            setPayTo(values.payTo);
            setClientPo(values.clientPo);
            setClientEmail(values.clientEmail);
            setCcEmails(values.ccEmails);
            setTimezone(values.timezone);
          }}
          onClose={() => console.log('first')}
        />
      )}

      <DocumentThemeScope className="communication-document deposit-document" ref={targetRef} document={quoteData} refreshSelection>
        <Stack
          direction={{ md: 'row', sm: 'column' }}
          spacing={{ xs: 1, sm: 3, md: 4 }}
          alignItems="center"
          justifyContent="space-around"
          bgcolor={companyData.primaryColor}
          sx={{
            position: 'relative', // added
            opacity: 0.9,
            mr: 6,
            ml: 6,
            mt: 2,
            color: '#000',
            '&:hover': {
              color: 'white'
            },
            '&:hover .quote-action-icons': {
              // added
              opacity: 1,
              visibility: 'visible',
              transform: 'translateY(0)'
            }
          }}
          p={2} data-document-header
         data-document-banner>
          <Stack data-banner-slot="logo">
            <ClientDocumentLogo branding={companyData} height={130} width={130} />
          </Stack>

          <Stack width={200} data-document-company-details data-banner-slot="company">
            <Typography color={companyData.secondaryColor} variant="h4">
              {companyData.name}
            </Typography>
            <Typography variant="h6" color={companyData.primaryTextColor}>
              {companyData.address}
            </Typography>
            <Typography variant="h6" color={companyData.primaryTextColor}>
              {companyData.phone}
            </Typography>
            <Typography variant="h6" color={companyData.primaryTextColor}>
              {companyData.email}
            </Typography>
          </Stack>
          <Stack spacing={1} direction="row" data-document-event-details data-banner-slot="event">
            <Stack spacing={1} textAlign="end">
              <Typography color={companyData.secondaryColor} variant="h5">
                Venue:
              </Typography>
              <Typography color={companyData.secondaryColor} variant="h5">
                Pay To:
              </Typography>

              <Typography color={companyData.secondaryColor} variant="h5">
                Job #:
              </Typography>

              <Typography color={companyData.secondaryColor} variant="h5">
                Event Location:
              </Typography>

              <Typography color={companyData.secondaryColor} variant="h5">
                Bill To:
              </Typography>
              <Typography color={companyData.secondaryColor} variant="h5">
                Client PO:
              </Typography>
            </Stack>
            <Stack spacing={1}>
              <Typography color={companyData.primaryTextColor} variant="h5">
                {venue || 'N/A'}
              </Typography>
              <Typography color={companyData.primaryTextColor} variant="h5">
                {payTo || 'N/A'}
              </Typography>

              <Typography color={companyData.primaryTextColor} variant="h5">
                {title || 'N/A'}
              </Typography>

              <Typography color={companyData.primaryTextColor} variant="h5">
                {address || 'N/A'}
              </Typography>

              <Typography color={companyData.primaryTextColor} variant="h5">
                {billTo || 'N/A'}
              </Typography>

              <Typography color={companyData.primaryTextColor} variant="h5">
                {clientPo || 'N/A'}
              </Typography>
            </Stack>
          </Stack>

          <Stack data-banner-slot="title">
            <Typography color={companyData.secondaryColor} variant="h1">
              Deposit Invoice
            </Typography>
            {savedValue && (
              <Stack alignItems="center" spacing={0.5} sx={{ mt: 1 }}>
                <Typography data-deposit-amount-label color={companyData.secondaryColor} variant="body2" sx={{ fontWeight: 700 }}>
                  Deposit Amount
                </Typography>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <Typography data-deposit-amount-value color={companyData.secondaryColor} variant="h3" sx={{ fontWeight: 700, whiteSpace: 'nowrap', '@media (max-width: 900px)': { fontSize: '24px' } }}>
                    {formatMoney(savedValue.amount)}
                  </Typography>
                  <Tooltip title="Edit deposit amount">
                    <IconButton
                      size="small"
                      aria-label="Edit deposit amount"
                      onClick={() => setModalOpen(true)}
                      sx={{ color: companyData.secondaryColor }}
                    >
                      <EditOutlined fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Stack>
            )}
          </Stack>

          {/* <Stack
            direction="row"
            spacing={1}
            className="quote-action-icons"
            sx={{
              position: 'absolute',
              top: 8,
              right: 12,
              color: '#ffffff',
              opacity: 0,
              visibility: 'hidden',
              transform: 'translateY(-6px)',
              transition: 'opacity .25s ease, transform .25s ease',
              '& .MuiSvgIcon-root': {
                cursor: 'pointer',
                fontSize: 26,
                transition: 'color .2s'
              },
              '& .MuiSvgIcon-root:hover': {
                color: companyData.secondaryColor
              }
            }}
          >
            <Email onClick={() => setEmailTemplateModalOpen(true)} />
          </Stack> */}

          {quoteData?.isDepositSent && (
            <Stack
              sx={{
                position: 'absolute',
                bottom: 8,
                right: 12,
                color: 'white'
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: '14px', fontWeight: 'medium' }}
              >
                Deposit Sent: {moment(quoteData.updatedAt).format('MM/DD/YY')}
              </Typography>
            </Stack>
          )}
        </Stack>

        <ResponsiveCommunicationTable><TableContainer sx={{ mt: 2, pr: 6, pl: 6 }}>
          <Table aria-label="spanning table" className="deposit-shift-worksheet">
            <TableHead>
              <TableRow sx={{ backgroundColor: companyData.secondaryColor, '& .MuiTableCell-root': { color: companyData.secondaryTextColor } }}>
                {/* <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Sr.
                </TableCell> */}
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Date
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Qty
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Position
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Call Time
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Notes
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Rate Type
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Call Type
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Meal Break
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Rate
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  ST Hrs
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  OT Hrs
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  DT Hrs
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Per Diem
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000'
                  }}
                >
                  Totals
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(groupedData).map(
                ([date, data]: [string, any]) => {
                  const totalQuantityForDate = data.positions.reduce(
                    (acc, position) => acc + position.quantity,
                    0
                  );
                  return (
                    <>
                      {data?.positions.map((position, index) => {
                        return (
                          <TableRow key={index} data-deposit-worksheet-row>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                textDecoration: 'underline'
                              }}
                              onClick={() => {
                                setSelectedShift(position);
                                handleOpenEditShift();
                              }}
                            >
                              <Tooltip title="Edit" arrow>
                                {/* <div>{formatDate(position?.startDate)}</div> */}
                                <div>
                                  {moment(position?.startDate)
                                    .format('ddd')
                                    .toUpperCase()}{' '}
                                  {formatDate(position?.startDate)}
                                </div>
                              </Tooltip>
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              {position?.quantity}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              {position?.position}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              {/* {position?.startTime}-{position?.endTime} */}
                              {position?.startTime && position?.endTime
                                ? `${moment(position.startTime, 'HH:mm').format(
                                    'h:mm A'
                                  )} - ${moment(
                                    position.endTime,
                                    'HH:mm'
                                  ).format('h:mm A')}`
                                : ''}
                              {/* {convertToAmPm(position?.startTime)}-
                                    {convertToAmPm(position?.endTime)} */}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              {position?.notes}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              <span style={unresolvedClientRate(position?.rateType, rateTypeOptions) ? { display: 'block', outline: '2px solid #ed6c02' } : undefined}>
                                {rateTypeDisplayLabel(position?.rateType, position?.rateTypeLabel || rateTypeOptions.find((option) => option.value === position?.rateType)?.label)}
                              </span>
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              {position?.callType}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              {position?.mealBreak}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              ${formatNumber(position?.rate)}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              {position?.registerHours}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              {position?.overTimeHours}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              {position?.DoubleTimeHours}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              ${formatNumber(position?.addOns)}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                border: `3px solid ${companyData.secondaryColor}`,
                                fontSize: '13px',
                                color: '#000'
                              }}
                            >
                              ${formatNumber(position?.totals)}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      <TableRow data-deposit-worksheet-row sx={{ backgroundColor: companyData.secondaryColor, '& .MuiTableCell-root': { color: companyData.secondaryTextColor } }}>
                        <TableCell
                          align="center"
                          sx={{ border: `3px solid ${companyData.secondaryColor}` }}
                        >
                          <Typography variant="h5" sx={{ color: '#000' }}>
                            Crew Subtotal
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ border: `3px solid ${companyData.secondaryColor}` }}
                        >
                          <Typography sx={{ color: '#000' }}>
                            {totalQuantityForDate}
                          </Typography>
                        </TableCell>
                        <TableCell
                          colSpan={10}
                          sx={{ border: `3px solid ${companyData.secondaryColor}` }}
                        />
                        <TableCell
                          align="center"
                          sx={{ border: `3px solid ${companyData.secondaryColor}` }}
                        >
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: 'bold', color: '#000' }}
                          >
                            Sub Total
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ border: `3px solid ${companyData.secondaryColor}` }}
                        >
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: 'bold', color: '#000' }}
                          >
                            ${formatNumber(data?.total)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                }
              )}

              <TableRow data-document-theme-exclude>
                {/* <TableCell
                  align="center"
                  sx={{ borderBottom: '1px solid gray' }}
                >
                  <Button
                    variant="text"
                    size="small"
                    sx={{
                      fontSize: '13px',
                      color: '#000',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      textDecoration: 'underline',
                      '&:hover': { backgroundColor: 'transparent' }
                    }}
                    onClick={handleOpenShift}
                  >
                    Add Shift
                  </Button>
                </TableCell> */}

                <TableCell
                  colSpan={12}
                  sx={{ borderBottom: '1px solid gray' }}
                />
                <TableCell
                  align="center"
                  sx={{ borderBottom: '1px solid gray' }}
                >
                  <Typography
                    variant="body1"
                    sx={{ color: '#000', whiteSpace: 'nowrap' }}
                  >
                    Admin Fee
                  </Typography>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ borderBottom: '1px solid gray' }}
                >
                  <Typography variant="body1" sx={{ color: '#000' }}>
                    ${formatNumber(adminFeeValue)}
                  </Typography>
                </TableCell>
              </TableRow>
              {discountValue > 0 && (
                <TableRow data-document-theme-exclude>
                  <TableCell
                    colSpan={12}
                    align="center"
                    sx={{ borderBottom: '1px solid gray' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 'bold', color: '#000' }}
                    >
                      {/* AMOUNT DUE */}
                    </Typography>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: '1px solid gray' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 'bold', color: '#000' }}
                    >
                      Discount
                    </Typography>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: '1px solid gray' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 'bold', color: '#000' }}
                    >
                      ${formatNumber(discountValue)}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}

              <TableRow data-document-theme-exclude>
                <TableCell
                  colSpan={12}
                  align="center"
                  sx={{ borderBottom: '1px solid gray' }}
                >
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 'bold', color: '#000' }}
                  >
                    {/* AMOUNT DUE */}
                  </Typography>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ borderBottom: '1px solid gray' }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      color: '#000',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Grand Total
                  </Typography>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ borderBottom: '1px solid gray' }}
                >
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 'bold', color: '#000' }}
                  >
                    ${formatNumber(formattedGrandTotalWithAdminFee)}
                  </Typography>
                </TableCell>
              </TableRow>
              {savedValue?.amount > 0 && (
                <TableRow data-document-theme-exclude>
                  <TableCell
                    colSpan={12}
                    align="center"
                    sx={{ borderBottom: '1px solid gray' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 'bold', color: '#000' }}
                    ></Typography>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: '1px solid gray' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 'bold', color: '#000' }}
                    >
                      {' '}
                      Deposit
                    </Typography>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: '1px solid gray' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 'bold', color: '#000' }}
                    >
                      ${formatNumber(savedValue?.amount)}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {savedValue?.amount > 0 && (
                <TableRow data-document-theme-exclude>
                  <TableCell
                    colSpan={12}
                    align="center"
                    sx={{ borderBottom: '1px solid gray' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 'bold', color: '#000' }}
                    ></Typography>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: '1px solid gray' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 'bold',
                        color: '#000',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Remaining Balance
                    </Typography>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: '1px solid gray' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 'bold', color: '#000' }}
                    >
                      ${formatNumber(dueNow)}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer></ResponsiveCommunicationTable>
      </DocumentThemeScope>
      <Stack sx={{ ml: 6, mr: 6 }}>
        {quoteData?.id && !isQuoteApprovedForActions(quoteData) && (
          <Alert severity="warning" sx={{ mb: 1 }}>
            This quote is not approved. Review the quote status or continue composing the deposit.
            Sending a deposit does not approve the quote.
          </Alert>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: 10
          }}
        >
          {/* Right Side Buttons */}
          <div
            style={{
              marginTop: 2,
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'row',
              gap: 10
            }}
          >
            {!loading && depositRequestSent && (
              <DepositSentStatus eventId={id} />
            )}
            {!loading && !depositRequestSent && (
              <Button
                disabled={savedValue?.amount <= 0}
                size="small"
                variant="outlined"
                sx={{
                  width: 150,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  fontWeight: 700,
                  ...adminActionButtonSx
                }}
                onClick={() => handleSendDeposit()}
              >
                Compose
              </Button>
            )}
            {loading && <CircularProgress size={15} />}
          </div>
        </div>
      </Stack>

      {/* <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ zIndex: 1000 }}
      >
        <Box sx={style}>
          <Stack mb={2}>
            <Autocomplete
              apiKey={process.env.REACT_APP_MAP_API_KEY}
              onPlaceSelected={handlePlaceSelect}
              style={{
                zIndex: 2000,
                padding: 10,
                borderRadius: 10,
                fontSize: 16
              }}
              placeholder="Location"
              options={{
                types: ['geocode', 'establishment']
              }}
              inputAutocompleteValue="country"
            />
          </Stack>

          <Stack>
            {latitude && longitude && (
              <iframe
                width="100%"
                height="400"
                src={`https://maps.google.com/maps?q=${latitude},${longitude}&output=embed`}
                aria-hidden="false"
              />
            )}
            <br />
          </Stack>

          <Stack direction="row" justifyContent="center" gap={1}>
            <Button
              onClick={handleClose}
              variant="contained"
              sx={{
                width: 100,

                backgroundColor: companyData.primaryColor,
                color: companyData.secondaryColor,
                '&:hover': {
                  backgroundColor: '#252422'
                }
              }}
            >
              Submit
            </Button>
            <Button
              variant="outlined"
              sx={{
                width: 100,
                borderColor: companyData.secondaryColor,
                borderWidth: 2,
                color: '#000000',
                '&:hover': {
                  borderColor: companyData.secondaryColor,
                  borderWidth: 2,
                  backgroundColor: 'none'
                }
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Stack>
    </Box>
      </Modal> */}

      <ShiftForm rateTypeOptions={rateTypeOptions}
        onSubmit={async (values) => {
          await handleAddPosition(values);
          handleSendQuote('update');
        }}
        handleCloseShift={() => handleCloseShift()}
        shiftOpen={shiftOpen}
        positionsArray={positionsArray}
      />

      <EditShiftForm rateTypeOptions={rateTypeOptions}
        shift={selectedShift}
        onDelete={(id) => {
          setPositions((prevPositions) =>
            prevPositions.filter((item) => item.id !== id)
          );
        }}
        onSubmit={(values) => {
          const posIndex = positions.findIndex((item) => item.id === values.id);
          positions[posIndex] = values;
          setPositions([...positions]);

          handleSendQuote('update');
        }}
        handleCloseShift={() => handleCloseEditShift()}
        shiftOpen={editShiftOpen}
        positionsArray={positionsArray}
      />

      {isModalOpen && <DepositModal
        open={isModalOpen}
        onOpenChange={setModalOpen}
        onSave={(value) => setSavedValue(value)}
        initialValue={savedValue?.amount > 0 ? { type: 'fixed', amount: savedValue.amount } : undefined}
        grandTotal={Number(formattedGrandTotalWithAdminFee)}
      />}

      {/* <DiscountModal
        open={isDiscountModalOpen}
        onOpenChange={setIsDiscountModalOpen}
        onSave={(value) => setDiscount(value)}
        initialValue={discount}
        grandTotal={Number(formattedGrandTotalWithAdminFee)}
      /> */}

      <AdminFeeModal
        open={isAdminFeeModalOpen}
        onOpenChange={setIsAdminFeeModalOpen}
        onSave={(value) => setAdminFee(value)}
        initialValue={adminFee}
        grandTotal={grandTotalWithoutAdminFee}
      />

      <EmailTemplateModal
        open={emailTemplateModalOpen}
        onClose={() => setEmailTemplateModalOpen(false)}
        onSave={handelSubmit}
        emailType="DEPOSIT"
        toEmails={clientEmail}
        ccEmails={ccEmails}
        quoteNumber={quoteData?.id}
        clientName={billTo}
        eventStartDate={quoteData?.startDate}
        eventEndDate={quoteData?.endDate}
        previewAmount={Number(savedValue?.amount)}
        initialBody={emailTemplateBody}
        address={address}
        venueName={venue}
        eventName={name}
        companyId={
          quoteData?.companyOwnership?.company?.id ||
          quoteData?.companyOwnership?.companyId
        }
      />
    </Card>
  );
};

export default function ConnectedUpdateDeposit() {
  return <ChatSocketProvider><UpdateDeposit /></ChatSocketProvider>;
}
